import React, { Component } from "react";
import {
  Row,
  Card,
  CardBody,
  Button,
  ModalBody,
  ModalHeader,
  Modal,
  FormGroup,
  Label,
  Input,
} from "reactstrap";
import PerfectScrollbar from "react-perfect-scrollbar";
import { Colxx, Separator } from "../../../components/common/CustomBootstrap";
import axios from "axios";
import { END_POINT, END_POINT_SOCKET } from "../../../constants/defaultValues";import createSocket from "../../../helpers/createSocket";
import Breadcrumb from "../../../containers/navs/Breadcrumb";
import {
  AddCommaNumber,
  getQrPayWithCashAndInfo,
  NotificatioErrController,
  NotificatioSucController,
  NotificatioSucSticky,
  formatDate,
} from "../../../helpers/Utils";
import IntlMessages from "../../../helpers/IntlMessages";
import { injectIntl } from "react-intl";
import Select from "react-select";
import CustomSelectInput from "../../../components/common/CustomSelectInput";
import SingleLightbox from "../../../components/pages/SingleLightbox";

class Upgrade extends Component {
  constructor(props) {
    super(props);
    const { intl } = props;

    const prices_basic = this.getPricesBasic(intl);
    const prices_pro = this.getPricesPro(intl);
    const prices_pro_auto = this.getPricesProAuto(intl);

    this.state = {
      isLoading: false,
      modal_basic: false,
      modal_pro: false,
      modal_pro_auto: false,
      modal_payment_success: false,
      modal_downgrade_confirm: false,
      pendingDowngradeItem: null,

      priceSelectedBasic: prices_basic[0],
      priceSelectedPro: prices_pro[0],
      priceSelectedProAuto: prices_pro_auto[0],

      license: [],
      activeTab: "1",
      accordion: [true, false, false, false, false],
      paymentInfo: null, // Realtime payment info from webhook

      item: {
        label: intl.formatMessage({ id: "upgrade.time.1m" }),
        price: intl.formatMessage(
          { id: "upgrade.price.currency" },
          { price: "349.000" },
        ),
        price_sale: "",
        value: "1",
      },
      upgradePreview: null,
      downgradePreview: null,
      targetDowngradePackage: null,

      // Promo code
      promoCode: "",
      promoLoading: false,
      promoError: "",
      promoData: null, // { id, code, discount_type, discount_value, discount, finalPrice }

      // Enterprise contact modal
      modal_enterprise: false,
      contactForm: { name: "", email: "", phone: "", message: "" },
      contactSubmitting: false,
      contactSent: false,
    };

    this.toggleBasic = this.toggleBasic.bind(this);
    this.togglePro = this.togglePro.bind(this);
    this.toggleProAuto = this.toggleProAuto.bind(this);
    this.handleActionSubmitBasic = this.handleActionSubmitBasic.bind(this);
    this.handleActionSubmitPro = this.handleActionSubmitPro.bind(this);
    this.handleActionSubmitProAuto = this.handleActionSubmitProAuto.bind(this);
  }

  getFeatures = (intl) => [
    {
      title: intl.formatMessage({ id: "upgrade.feature.billing" }),
      free: true,
      basic: true,
      pro: true,
      pro_auto: true,
      enterprise: true,
    },
    {
      title: intl.formatMessage({ id: "upgrade.feature.print_invoice" }),
      free: true,
      basic: true,
      pro: true,
      pro_auto: true,
      enterprise: true,
    },
    {
      title: intl.formatMessage({ id: "upgrade.feature.accounts" }),
      free: true,
      basic: true,
      pro: true,
      pro_auto: true,
      enterprise: true,
    },
    {
      title: intl.formatMessage({ id: "upgrade.feature.sales" }),
      free: true,
      basic: true,
      pro: true,
      pro_auto: true,
      enterprise: true,
    },
    {
      title: intl.formatMessage({ id: "upgrade.feature.products" }),
      free: intl.formatMessage({ id: "upgrade.value.products.free" }),
      basic: intl.formatMessage({ id: "upgrade.value.products.basic" }),
      pro: intl.formatMessage({ id: "upgrade.value.unlimited" }),
      pro_auto: intl.formatMessage({ id: "upgrade.value.unlimited" }),
      enterprise: intl.formatMessage({ id: "upgrade.value.unlimited" }),
    },
    {
      title: intl.formatMessage({ id: "upgrade.feature.materials" }),
      free: intl.formatMessage({ id: "upgrade.value.materials.free" }),
      basic: intl.formatMessage({ id: "upgrade.value.materials.basic" }),
      pro: intl.formatMessage({ id: "upgrade.value.unlimited" }),
      pro_auto: intl.formatMessage({ id: "upgrade.value.unlimited" }),
      enterprise: intl.formatMessage({ id: "upgrade.value.unlimited" }),
    },
    {
      title: intl.formatMessage({ id: "upgrade.feature.staff" }),
      free: intl.formatMessage({ id: "upgrade.value.staff.free" }),
      basic: intl.formatMessage({ id: "upgrade.value.unlimited" }),
      pro: intl.formatMessage({ id: "upgrade.value.unlimited" }),
      pro_auto: intl.formatMessage({ id: "upgrade.value.unlimited" }),
      enterprise: intl.formatMessage({ id: "upgrade.value.unlimited" }),
    },
    {
      title: intl.formatMessage({ id: "upgrade.feature.reports" }),
      free: intl.formatMessage({ id: "upgrade.value.reports.basic" }),
      basic: intl.formatMessage({ id: "upgrade.value.reports.detailed" }),
      pro: intl.formatMessage({ id: "upgrade.value.reports.advanced" }),
      pro_auto: intl.formatMessage({ id: "upgrade.value.reports.advanced" }),
      enterprise: intl.formatMessage({ id: "upgrade.value.reports.advanced" }),
    },
    {
      title: intl.formatMessage({ id: "upgrade.feature.chain" }),
      free: false,
      basic: false,
      pro: true,
      pro_auto: true,
      enterprise: true,
    },
    {
      title: intl.formatMessage({ id: "upgrade.feature.social" }),
      free: false,
      basic: false,
      pro: true,
      pro_auto: true,
      enterprise: true,
    },
    {
      title: intl.formatMessage({ id: "upgrade.feature.shipping" }),
      free: false,
      basic: false,
      pro: true,
      pro_auto: true,
      enterprise: true,
    },
    {
      title: intl.formatMessage({ id: "upgrade.feature.ecommerce" }),
      free: false,
      basic: false,
      pro: true,
      pro_auto: true,
      enterprise: true,
    },
    {
      title: intl.formatMessage({ id: "upgrade.feature.einvoice" }),
      free: false,
      basic: false,
      pro: true,
      pro_auto: true,
      enterprise: true,
    },
    {
      title: intl.formatMessage({ id: "upgrade.feature.api" }),
      free: false,
      basic: false,
      pro: false,
      pro_auto: true,
      enterprise: true,
    },
    {
      title: intl.formatMessage({ id: "upgrade.feature.api-limit" }),
      pro_auto: intl.formatMessage({ id: "upgrade.value.api.limit" }),
      enterprise: intl.formatMessage({ id: "upgrade.value.api.custom" }),
    },
    {
      title: intl.formatMessage({ id: "upgrade.feature.automation" }),
      free: false,
      basic: false,
      pro: false,
      pro_auto: true,
      enterprise: true,
    },
    {
      title: intl.formatMessage({ id: "upgrade.feature.support" }),
      free: intl.formatMessage({ id: "upgrade.value.support.docs" }),
      basic: intl.formatMessage({ id: "upgrade.value.support.online" }),
      pro: intl.formatMessage({ id: "upgrade.value.support.online" }),
      pro_auto: intl.formatMessage({ id: "upgrade.value.support.priority" }),
      enterprise: intl.formatMessage({ id: "upgrade.value.support.priority" }),
    },
  ];

  getPricesBasic = (intl) => [
    {
      label: intl.formatMessage({ id: "upgrade.time.1m" }),
      price: "99000",
      price_sale: "",
      value: "1m",
    },
    {
      label: intl.formatMessage({ id: "upgrade.time.6m" }),
      price: "594000",
      price_sale: "",
      value: "6m",
    },
    {
      label: intl.formatMessage({ id: "upgrade.time.1y" }),
      price: "1188000",
      price_sale: "",
      value: "1y",
    },
    {
      label: intl.formatMessage({ id: "upgrade.time.2y" }),
      price: "2376000",
      price_sale: "",
      value: "2y",
    },
    {
      label: intl.formatMessage({ id: "upgrade.time.5y" }),
      price: "5940000",
      price_sale: "",
      value: "5y",
    },
  ];

  getPricesPro = (intl) => [
    {
      label: intl.formatMessage({ id: "upgrade.time.1m" }),
      price: "299000",
      price_sale: "",
      value: "1m",
    },
    {
      label: intl.formatMessage({ id: "upgrade.time.6m" }),
      price: "1794000",
      price_sale: "",
      value: "6m",
    },
    {
      label: intl.formatMessage({ id: "upgrade.time.1y" }),
      price: "3588000",
      price_sale: "",
      value: "1y",
    },
    {
      label: intl.formatMessage({ id: "upgrade.time.2y" }),
      price: "7176000",
      price_sale: "",
      value: "2y",
    },
    {
      label: intl.formatMessage({ id: "upgrade.time.5y" }),
      price: "17940000",
      price_sale: "",
      value: "5y",
    },
  ];

  getPricesProAuto = (intl) => [
    {
      label: intl.formatMessage({ id: "upgrade.time.1m" }),
      price: "599000",
      price_sale: "",
      value: "1m",
    },
    {
      label: intl.formatMessage({ id: "upgrade.time.6m" }),
      price: "3594000",
      price_sale: "",
      value: "6m",
    },
    {
      label: intl.formatMessage({ id: "upgrade.time.1y" }),
      price: "7188000",
      price_sale: "",
      value: "1y",
    },
    {
      label: intl.formatMessage({ id: "upgrade.time.2y" }),
      price: "14376000",
      price_sale: "",
      value: "2y",
    },
    {
      label: intl.formatMessage({ id: "upgrade.time.5y" }),
      price: "35940000",
      price_sale: "",
      value: "5y",
    },
  ];

  componentDidMount() {
    this.dataRender();
    this.initSocket();
  }

  componentWillUnmount() {
    if (this.socket) {
      this.socket.disconnect();
    }
  }

  initSocket = () => {
    const user_id = localStorage.getItem("user_id");

    this.socket = createSocket();
    this.socket.emit("join room", { room_id: user_id });

    // Listen for payment received event
    this.socket.on("upgrade-payment-received", (data) => {
      console.log("Payment received:", data);
      NotificatioSucController(
        `Đã nhận thanh toán ${data.amount.toLocaleString("vi-VN")}đ từ ${
          data.gateway
        }`,
      );
    });

    // Listen for upgrade completed event
    this.socket.on("upgrade-completed", (data) => {
      console.log("Upgrade completed:", data);
      this.setState({
        modal_payment_success: true,
        paymentInfo: data,
        modal_basic: false, // Close payment modals
        modal_pro: false,
        modal_pro_auto: false,
      });
      // Refresh license data
      this.dataRender();
      NotificatioSucSticky(
        "Nâng cấp tài khoản thành công! Vui lòng kiểm tra lại hạn sử dụng.",
      );
    });

    // Listen for payment pending review
    this.socket.on("upgrade-payment-pending-review", (data) => {
      console.log("Payment pending review:", data);
      NotificatioSucController(data.message);
    });
  };

  togglePaymentSuccess = () => {
    this.setState({
      modal_payment_success: !this.state.modal_payment_success,
    });
  };

  dataRender = () => {
    let tokenStr = localStorage.getItem("access_token");
    axios
      .get(`${END_POINT + "/user-license"}`, {
        headers: {
          Authorization: `Bearer ${tokenStr}`,
        },
      })
      .then((res) => {
        return res.data;
      })
      .then((data) => {
        this.setState({
          isLoading: true,
          license: data.data,
        });
      })
      .catch((err) => {
        NotificatioErrController(err.response.data.responseText);
      });
  };

  fetchUpgradePreview = (target_package, duration) => {
    let tokenStr = localStorage.getItem("access_token");
    this.setState({ upgradePreview: null });
    axios
      .post(
        `${END_POINT}/user-license/preview-upgrade`,
        {
          target_package,
          duration,
        },
        { headers: { Authorization: `Bearer ${tokenStr}` } },
      )
      .then((res) => {
        if (res.data.status === 200) {
          this.setState({ upgradePreview: res.data.data });
        }
      })
      .catch((err) => console.log(err));
  };

  toggleBasic() {
    const isOpen = !this.state.modal_basic;
    this.setState({ modal_basic: isOpen, promoCode: "", promoData: null, promoError: "" });
    if (isOpen)
      this.fetchUpgradePreview("basic", this.state.priceSelectedBasic.value);
  }

  togglePro() {
    const isOpen = !this.state.modal_pro;
    this.setState({ modal_pro: isOpen, promoCode: "", promoData: null, promoError: "" });
    if (isOpen)
      this.fetchUpgradePreview("pro", this.state.priceSelectedPro.value);
  }

  toggleProAuto() {
    const isOpen = !this.state.modal_pro_auto;
    this.setState({ modal_pro_auto: isOpen, promoCode: "", promoData: null, promoError: "" });
    if (isOpen)
      this.fetchUpgradePreview(
        "pro_auto",
        this.state.priceSelectedProAuto.value,
      );
  }

  handleActionSubmitBasic() {
    this.handleActionSubmitGeneric("basic", this.state.priceSelectedBasic);
  }

  handleActionSubmitPro() {
    this.handleActionSubmitGeneric("pro", this.state.priceSelectedPro);
  }

  handleActionSubmitProAuto() {
    this.handleActionSubmitGeneric("pro_auto", this.state.priceSelectedProAuto);
  }

  handleActionSubmitGeneric(purchased_package, priceSelected) {
    let tokenStr = localStorage.getItem("access_token");
    let price = priceSelected.price_sale
      ? priceSelected.price_sale
      : priceSelected.price;
    price = parseInt(price);

    if (
      this.state.upgradePreview &&
      this.state.upgradePreview.package.toUpperCase() ===
        purchased_package.toUpperCase() &&
      this.state.upgradePreview.duration === priceSelected.value
    ) {
      price = this.state.upgradePreview.finalPrice;
    }

    // Apply promo discount
    const { promoData } = this.state;
    if (promoData && promoData.discount) {
      price = Math.max(0, price - promoData.discount);
    }

    axios
      .post(
        `${END_POINT + "/user-license/requirement"}`,
        {
          time: priceSelected.value,
          purchased_package,
          price,
          promo_code: promoData ? promoData.code : undefined,
        },
        {
          headers: {
            Authorization: `Bearer ${tokenStr}`,
          },
        },
      )
      .then((res) => {
        return res.data;
      })
      .then((data) => {
        // Record promo usage
        if (promoData) {
          axios
            .post(
              `${END_POINT}/user-license/record-promo-usage`,
              { promo_id: promoData.id },
              { headers: { Authorization: `Bearer ${tokenStr}` } },
            )
            .catch(() => {});
        }

        NotificatioSucController(data.responseText);
        this.setState({
          modal_basic: false,
          modal_pro: false,
          modal_pro_auto: false,
          upgradePreview: null,
          promoCode: "",
          promoData: null,
          promoError: "",
        });
        // Refresh license data (especially important for instant upgrades)
        this.dataRender();
      })
      .catch((err) => {
        NotificatioErrController(err.response.data.responseText);
      });
  }

  handleChangeValueSelectPriceBasic = (e) => {
    this.setState({ priceSelectedBasic: e, promoData: null, promoCode: "", promoError: "" });
    this.fetchUpgradePreview("basic", e.value);
  };

  handleChangeValueSelectPricePro = (e) => {
    this.setState({ priceSelectedPro: e, promoData: null, promoCode: "", promoError: "" });
    this.fetchUpgradePreview("pro", e.value);
  };

  handleChangeValueSelectPriceProAuto = (e) => {
    this.setState({ priceSelectedProAuto: e, promoData: null, promoCode: "", promoError: "" });
    this.fetchUpgradePreview("pro_auto", e.value);
  };

  toggleTab = (tab) => {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
      });
    }
  };

  toggleAccordion = (tab) => {
    const prevState = this.state.accordion;
    const state = prevState.map((x, index) => (tab === index ? !x : false));
    this.setState({
      accordion: state,
    });
  };

  toggleDowngradeConfirm = () => {
    this.setState({
      modal_downgrade_confirm: !this.state.modal_downgrade_confirm,
    });
  };

  // Promo code
  onApplyPromoCode = (targetPackage, price) => {
    const { promoCode } = this.state;
    if (!promoCode.trim()) return;

    this.setState({ promoLoading: true, promoError: "" });
    let tokenStr = localStorage.getItem("access_token");

    axios
      .post(
        `${END_POINT}/user-license/validate-promo`,
        {
          code: promoCode.trim(),
          target_package: targetPackage,
          price,
        },
        { headers: { Authorization: `Bearer ${tokenStr}` } },
      )
      .then((res) => {
        this.setState({
          promoLoading: false,
          promoData: res.data.data,
          promoError: "",
        });
      })
      .catch((err) => {
        this.setState({
          promoLoading: false,
          promoData: null,
          promoError:
            err.response?.data?.responseText || "Mã khuyến mại không hợp lệ",
        });
      });
  };

  onRemovePromoCode = () => {
    this.setState({
      promoCode: "",
      promoData: null,
      promoError: "",
    });
  };

  // Enterprise contact
  toggleEnterprise = () => {
    this.setState((prev) => ({
      modal_enterprise: !prev.modal_enterprise,
      contactForm: { name: "", email: "", phone: "", message: "" },
      contactSubmitting: false,
      contactSent: false,
    }));
  };

  onContactFormChange = (field, value) => {
    this.setState((prev) => ({
      contactForm: { ...prev.contactForm, [field]: value },
    }));
  };

  handleContactSubmit = () => {
    const { contactForm } = this.state;
    if (!contactForm.name.trim() || !contactForm.email.trim() || !contactForm.message.trim()) {
      NotificatioErrController("Vui lòng điền đầy đủ thông tin bắt buộc");
      return;
    }

    this.setState({ contactSubmitting: true });
    let tokenStr = localStorage.getItem("access_token");

    axios
      .post(
        `${END_POINT}/user-license/enterprise-contact`,
        contactForm,
        { headers: { Authorization: `Bearer ${tokenStr}` } },
      )
      .then((res) => {
        this.setState({ contactSubmitting: false, contactSent: true });
        NotificatioSucController(res.data.responseText || "Gửi thành công!");
      })
      .catch((err) => {
        this.setState({ contactSubmitting: false });
        NotificatioErrController(
          err.response?.data?.responseText || "Gửi thất bại, vui lòng thử lại",
        );
      });
  };

  onDowngradeClick = (item, target_package) => {
    let tokenStr = localStorage.getItem("access_token");
    axios
      .post(
        `${END_POINT}/user-license/preview-downgrade`,
        {
          target_package,
        },
        { headers: { Authorization: `Bearer ${tokenStr}` } },
      )
      .then((res) => {
        this.setState({
          downgradePreview: res.data.data,
          targetDowngradePackage: target_package,
          modal_downgrade_confirm: true,
        });
      })
      .catch((err) => {
        NotificatioErrController(err.response?.data?.responseText || "Lỗi");
      });
  };

  handleDowngradeConfirm = () => {
    let tokenStr = localStorage.getItem("access_token");
    const { targetDowngradePackage } = this.state;

    axios
      .post(
        `${END_POINT}/user-license/downgrade`,
        {
          target_package: targetDowngradePackage,
        },
        { headers: { Authorization: `Bearer ${tokenStr}` } },
      )
      .then((res) => {
        NotificatioSucController(res.data.responseText);
        this.setState({
          modal_downgrade_confirm: false,
          downgradePreview: null,
        });
        window.location.reload();
      })
      .catch((err) => {
        NotificatioErrController(err.response?.data?.responseText || "Lỗi");
        this.setState({ modal_downgrade_confirm: false });
      });
  };

  onClickedItem = (item) => {
    const { label, price, price_sale, value } = this.state;
    this.setState((prev) => ({
      ...prev,
      item: {
        ...prev.item,
        label: item.label,
        price: item.price,
        price_sale: item.price_sale,
        value: item.value,
      },
    }));
  };

  renderPaymentModal(
    isOpen,
    toggle,
    priceSelected,
    priceOptions,
    handleChange,
    handleSubmit,
    targetPackage,
  ) {
    const { intl } = this.props;
    const { promoCode, promoLoading, promoError, promoData } = this.state;
    const companyUUID = localStorage.getItem("companyUUID");
    // MBBank info
    const bin = 970422;
    const account = "0935777736";
    const accountName = "Phạm Quang Thành";
    const bankName = "MBBank";

    const priceBeforePromo =
      this.state.upgradePreview &&
      this.state.upgradePreview.duration === priceSelected.value
        ? this.state.upgradePreview.finalPrice
        : priceSelected.price_sale !== ""
          ? priceSelected.price_sale
          : priceSelected.price;

    const promoDiscount = promoData ? promoData.discount : 0;
    const price = Math.max(0, parseInt(priceBeforePromo) - promoDiscount);

    const isInstant =
      (this.state.upgradePreview &&
        this.state.upgradePreview.duration === priceSelected.value &&
        this.state.upgradePreview.finalPrice <= 0) ||
      price <= 0;

    return (
      <Modal isOpen={isOpen} toggle={toggle}>
        <ModalHeader toggle={toggle}>
          <IntlMessages id="upgrade.modal.payment.title" />
        </ModalHeader>
        <ModalBody>
          {isInstant ? (
            <div className="text-center">
              <div className="mb-3">
                <i
                  className="iconsminds-wallet text-success"
                  style={{ fontSize: "64px" }}
                />
                <h4 className="mt-3 text-success font-weight-bold">
                  <IntlMessages id="upgrade.modal.payment.instant-title" />
                </h4>
                <p className="text-muted mb-3">
                  <IntlMessages id="upgrade.modal.payment.deduct-note" />
                </p>
              </div>
              <div className="text-left mb-3">
                <h6 className="text-muted">
                  <IntlMessages id="upgrade.modal.payment.term" />
                </h6>
                <Select
                  defaultValue={priceSelected}
                  components={{ Input: CustomSelectInput }}
                  className="react-select"
                  classNamePrefix="react-select"
                  name="product"
                  options={priceOptions}
                  onChange={(newValue) => handleChange(newValue)}
                  placeholder={<IntlMessages id="pages.select-product" />}
                />
              </div>
              {this.state.upgradePreview && (
              <div className="text-left mx-auto" style={{ maxWidth: "320px" }}>
                <div className="d-flex justify-content-between mb-2">
                  <span className="text-muted">
                    <IntlMessages id="upgrade.modal.payment.original-price" />
                  </span>
                  <span>{AddCommaNumber(this.state.upgradePreview.originalPrice)} đ</span>
                </div>
                {this.state.upgradePreview.remainingValue > 0 && (
                  <div className="d-flex justify-content-between mb-2">
                    <span className="text-muted">
                      <IntlMessages id="upgrade.modal.payment.remaining" />
                    </span>
                    <span className="text-success">
                      - {AddCommaNumber(this.state.upgradePreview.remainingValue)} đ
                    </span>
                  </div>
                )}
                {this.state.upgradePreview.creditBalance > 0 && (
                  <div className="d-flex justify-content-between mb-2">
                    <span className="text-muted">
                      <IntlMessages id="upgrade.modal.payment.wallet" />
                    </span>
                    <span className="text-success">
                      - {AddCommaNumber(
                        Math.min(
                          this.state.upgradePreview.creditBalance,
                          Math.max(0, this.state.upgradePreview.originalPrice - this.state.upgradePreview.remainingValue),
                        )
                      )} đ
                    </span>
                  </div>
                )}
                {promoDiscount > 0 && (
                  <div className="d-flex justify-content-between mb-2">
                    <span className="text-muted">Khuyến mại</span>
                    <span className="text-success">
                      - {AddCommaNumber(promoDiscount)} đ
                    </span>
                  </div>
                )}
                <hr className="my-2" />
                <div className="d-flex justify-content-between mb-2">
                  <span className="font-weight-bold">
                    <IntlMessages id="upgrade.modal.payment.total" />
                  </span>
                  <span className="font-weight-bold text-primary">{AddCommaNumber(price)} đ</span>
                </div>
                {this.state.upgradePreview.remainingValue > this.state.upgradePreview.originalPrice && (
                  <div className="d-flex justify-content-between mb-2">
                    <span className="text-muted">
                      <IntlMessages id="upgrade.modal.payment.surplus-refund" />
                    </span>
                    <span className="text-info font-weight-bold">
                      + {AddCommaNumber(
                        Math.floor(this.state.upgradePreview.remainingValue - this.state.upgradePreview.originalPrice)
                      )} đ
                    </span>
                  </div>
                )}
              </div>
              )}
            </div>
          ) : (
            <div>
              <p>
                <IntlMessages id="upgrade.modal.payment.instruction" />
              </p>
              <Separator className="mb-3" />
              <h6 className="text-muted">
                <IntlMessages id="upgrade.modal.payment.term" />{" "}
              </h6>
              <Select
                defaultValue={priceSelected}
                components={{ Input: CustomSelectInput }}
                className="react-select"
                classNamePrefix="react-select"
                name="product"
                options={priceOptions}
                onChange={(newValue) => handleChange(newValue)}
                placeholder={<IntlMessages id="pages.select-product" />}
                menuPlacement="top"
              />
              <div className="mb-3" />
              <Row className="d-flex align-items-center">
                <Colxx xxs="4">
                  <p className="text-small text-muted text-center px-3 mb-0">
                    <IntlMessages id="upgrade.modal.payment.scan-note" />
                  </p>
                  <SingleLightbox
                    thumb={getQrPayWithCashAndInfo(
                      bin,
                      account,
                      price,
                      "VMASS" + companyUUID,
                    )}
                    large={getQrPayWithCashAndInfo(
                      bin,
                      account,
                      price,
                      "VMASS" + companyUUID,
                    )}
                    className="img-thumbnail card-img qrpay"
                  />
                </Colxx>
                <Colxx xxs="3">
                  <p className="text-muted mb-2">
                    <IntlMessages id="upgrade.modal.payment.owner" />
                  </p>
                  <p className="text-muted mb-2">
                    <IntlMessages id="upgrade.modal.payment.account" />
                  </p>
                  <p className="text-muted mb-2">
                    <IntlMessages id="upgrade.modal.payment.bank" />
                  </p>
                  <p className="text-muted mb-2">
                    <IntlMessages id="upgrade.modal.payment.amount" />
                  </p>
                  <p className="text-muted mb-2">
                    <IntlMessages id="upgrade.modal.payment.content" />
                  </p>
                </Colxx>
                <Colxx xxs="5">
                  <p className="mb-2">{accountName}</p>
                  <p className="mb-2">{account}</p>
                  <p className="mb-2">{bankName}</p>
                  {this.state.upgradePreview &&
                  this.state.upgradePreview.duration === priceSelected.value ? (
                    <div>
                      {this.state.upgradePreview.remainingValue > 0 && (
                        <p className="text-success text-small mb-1">
                          -{" "}
                          {AddCommaNumber(
                            this.state.upgradePreview.remainingValue,
                          )}{" "}
                          đ{" "}
                          <IntlMessages id="upgrade.modal.payment.remaining" />
                        </p>
                      )}
                      {this.state.upgradePreview.creditBalance > 0 && (
                        <p className="text-success text-small mb-1">
                          -{" "}
                          {AddCommaNumber(
                            this.state.upgradePreview.creditBalance,
                          )}{" "}
                          đ <IntlMessages id="upgrade.modal.payment.wallet" />
                        </p>
                      )}
                      {promoDiscount > 0 && (
                        <p className="text-success text-small mb-1">
                          -{" "}
                          {AddCommaNumber(promoDiscount)}{" "}
                          đ (KM)
                        </p>
                      )}
                      <p className="text-primary font-weight-bold mb-2">
                        {promoDiscount > 0 ? (
                          <span>
                            <span className="text-muted text-small font-weight-normal" style={{ textDecoration: "line-through" }}>
                              {AddCommaNumber(this.state.upgradePreview.finalPrice)} đ
                            </span>{" "}
                            {AddCommaNumber(price)} đ
                          </span>
                        ) : (
                          <span>{AddCommaNumber(this.state.upgradePreview.finalPrice)} đ</span>
                        )}
                      </p>
                    </div>
                  ) : priceSelected.price_sale !== "" ? (
                    <div className="mb-2">
                      <span className="text-muted text-small text-deco-line-through">
                        {AddCommaNumber(priceSelected.price)}
                      </span>{" "}
                      {promoDiscount > 0 ? (
                        <span>
                          <span className="text-muted text-small" style={{ textDecoration: "line-through" }}>
                            {AddCommaNumber(priceSelected.price_sale)} đ
                          </span>{" "}
                          <span className="text-primary font-weight-bold">
                            {AddCommaNumber(price)} đ
                          </span>
                        </span>
                      ) : (
                        <span className="text-primary">{`${AddCommaNumber(
                          priceSelected.price_sale,
                        )} đ`}</span>
                      )}
                    </div>
                  ) : (
                    <p className="text-primary mb-2">
                      {promoDiscount > 0 ? (
                        <span>
                          <span className="text-muted text-small font-weight-normal" style={{ textDecoration: "line-through" }}>
                            {AddCommaNumber(priceSelected.price)} đ
                          </span>{" "}
                          <span className="font-weight-bold">{AddCommaNumber(price)} đ</span>
                        </span>
                      ) : (
                        `${AddCommaNumber(priceSelected.price)} đ`
                      )}
                    </p>
                  )}
                  <p className="mb-2">VMASS{companyUUID}</p>
                </Colxx>
              </Row>
            </div>
          )}

          {/* Promo Code Section */}
          <div className="mt-3 mb-3 p-3" style={{ backgroundColor: "#f8f9fa", borderRadius: 8 }}>
            <p className="font-weight-bold text-small mb-2">
              <i className="simple-icon-tag mr-1" />
              <IntlMessages id="upgrade.promo.title" />
            </p>
            {promoData ? (
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <span className="badge badge-success mr-2">
                    {promoData.code}
                  </span>
                  <span className="text-success text-small">
                    -{AddCommaNumber(promoData.discount)}đ
                  </span>
                </div>
                <Button
                  color="link"
                  size="sm"
                  className="text-danger p-0"
                  onClick={this.onRemovePromoCode}
                >
                  <IntlMessages id="upgrade.promo.remove" />
                </Button>
              </div>
            ) : (
              <div>
                <div className="d-flex">
                  <input
                    type="text"
                    className="form-control form-control-sm mr-2"
                    placeholder={intl.formatMessage({
                      id: "upgrade.promo.placeholder",
                    })}
                    value={promoCode}
                    onChange={(e) =>
                      this.setState({
                        promoCode: e.target.value.toUpperCase(),
                        promoError: "",
                      })
                    }
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        this.onApplyPromoCode(targetPackage, priceBeforePromo);
                      }
                    }}
                    disabled={promoLoading}
                  />
                  <Button
                    color="outline-primary"
                    size="sm"
                    onClick={() =>
                      this.onApplyPromoCode(targetPackage, priceBeforePromo)
                    }
                    disabled={promoLoading || !promoCode.trim()}
                    style={{ whiteSpace: "nowrap" }}
                  >
                    {promoLoading ? "..." : <IntlMessages id="upgrade.promo.apply" />}
                  </Button>
                </div>
                {promoError && (
                  <small className="text-danger mt-1 d-block">
                    {promoError}
                  </small>
                )}
              </div>
            )}
          </div>

          <div className="text-center">
            <div className="mb-3" />
            {!isInstant && (
              <span className="text-small text-muted">
                <IntlMessages id="upgrade.modal.payment.manual-note" />
              </span>
            )}
            <div className="mt-3">
              <Button color="primary" onClick={handleSubmit}>
                {isInstant ? (
                  <IntlMessages id="upgrade.modal.payment.btn-instant" />
                ) : (
                  <IntlMessages id="upgrade.modal.payment.btn-submit" />
                )}
              </Button>
            </div>
          </div>
        </ModalBody>
      </Modal>
    );
  }

  render() {
    let {
      isLoading,
      modal_basic,
      modal_pro,
      modal_pro_auto,
      modal_payment_success,
      priceSelectedBasic,
      priceSelectedPro,
      priceSelectedProAuto,
      license,
      paymentInfo,
      modal_enterprise,
      contactForm,
      contactSubmitting,
      contactSent,
    } = this.state;
    const { intl } = this.props;
    const features = this.getFeatures(intl);

    const packageConfig = [
      {
        key: "free",
        title: intl.formatMessage({ id: "upgrade.package.free.title" }),
        price: "0",
        sub: "đ",
        icon: "iconsminds-bread",
        color: "text-muted",
        btnText: intl.formatMessage({ id: "upgrade.using" }),
        action: null,
        checkExpired: true,
      },
      {
        key: "basic",
        title: intl.formatMessage({ id: "upgrade.package.basic.title" }),
        price: "99.000",
        sub: "đ/tháng",
        icon: "iconsminds-coins",
        color: "text-primary",
        btnText: intl.formatMessage({ id: "upgrade.upgrade" }),
        action: this.toggleBasic,
      },
      {
        key: "pro",
        title: intl.formatMessage({ id: "upgrade.package.pro.title" }),
        price: "299.000",
        sub: "đ/tháng",
        icon: "iconsminds-diamond",
        color: "text-primary",
        btnText: intl.formatMessage({ id: "upgrade.upgrade" }),
        action: this.togglePro,
        isPopular: true,
      },
      {
        key: "pro_auto",
        title: intl.formatMessage({ id: "upgrade.package.pro-auto.title" }),
        price: "599.000",
        sub: "đ/tháng",
        icon: "iconsminds-gear",
        color: "text-danger",
        btnText: intl.formatMessage({ id: "upgrade.upgrade" }),
        action: this.toggleProAuto,
      },
      {
        key: "enterprise",
        title: intl.formatMessage({ id: "upgrade.package.enterprise.title" }),
        price: intl.formatMessage({ id: "upgrade.contact" }),
        sub: "",
        icon: "iconsminds-building",
        color: "text-secondary",
        btnText: intl.formatMessage({ id: "upgrade.contact" }),
        action: this.toggleEnterprise,
      },
    ];

    const getButton = (item) => {
      const ranks = {
        free: 0,
        basic: 1,
        pro: 2,
        pro_auto: 3,
        enterprise: 4,
      };
      let currentKey = "free";
      if (license && !license.isExpired && license.purchased_package) {
        currentKey = license.purchased_package.toLowerCase();
        if (currentKey === "platinum") currentKey = "pro";
      }

      const itemRank = ranks[item.key] !== undefined ? ranks[item.key] : -1;
      const currentRank =
        ranks[currentKey] !== undefined ? ranks[currentKey] : 0;

      const isCurrent = item.key === currentKey;
      const isLower = itemRank < currentRank;

      // Calculate remaining days for current package
      const getRemainingDays = () => {
        if (!license || license.isExpired || !license.expired_date || license.upgraded) return null;
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        // Parse as local midnight (not UTC) to match today's timezone
        const parts = license.expired_date.split("-");
        const expiry = new Date(parts[0], parts[1] - 1, parts[2]);
        const diffDays = Math.round((expiry - today) / (1000 * 60 * 60 * 24));
        return diffDays > 0 ? diffDays : null;
      };

      const remainingDays = getRemainingDays();

      if (isCurrent) {
        if (currentKey === "free") {
          return (
            <div>
              <Button
                color="secondary"
                outline
                disabled
                className="btn-multiple-state btn-shadow"
                style={{ opacity: 0.7 }}
              >
                <IntlMessages id="upgrade.activated" />
              </Button>
              {remainingDays && (
                <p className="text-muted text-small mt-3 mb-0">
                  <i className="simple-icon-clock mr-1" />
                  <IntlMessages id="upgrade.remaining-days" values={{ days: remainingDays }} />
                </p>
              )}
            </div>
          );
        } else if (currentKey === "enterprise") {
          return (
            <div>
              <Button
                color="secondary"
                outline
                className="btn-multiple-state btn-shadow"
                onClick={item.action}
              >
                <IntlMessages id="upgrade.using" />
              </Button>
              {license.upgraded && (
                <p className="text-success text-small mt-2 mb-0">
                  <i className="simple-icon-infinity mr-1" />
                  <IntlMessages id="upgrade.lifetime" />
                </p>
              )}
            </div>
          );
        } else {
          return (
            <div>
              <Button
                color="primary"
                className="btn-multiple-state btn-shadow"
                onClick={item.action}
              >
                <IntlMessages id="upgrade.renew" />
              </Button>
              {remainingDays && (
                <p className="text-muted text-small mt-2 mb-0">
                  <i className="simple-icon-clock mr-1" />
                  <IntlMessages id="upgrade.remaining-days" values={{ days: remainingDays }} />
                </p>
              )}
            </div>
          );
        }
      }

      if (item.key === "free") {
        return <div style={{ height: "38px" }}></div>;
      }

      if (isLower) {
        return (
          <Button
            color="secondary"
            className="btn-multiple-state btn-shadow border-0"
            onClick={() => this.onDowngradeClick(null, item.key)}
            disabled={!item.action}
            outline
          >
            <IntlMessages id="upgrade.downgrade" />
          </Button>
        );
      }

      return (
        <Button
          color={"primary"}
          className={`btn-multiple-state btn-shadow ${
            item.isPopular ? "default" : "outline"
          }`}
          onClick={item.action}
          disabled={!item.action}
          outline={!item.isPopular}
          // style={
          //   item.isPopular
          //     ? {
          //         backgroundColor: "#FF5722",
          //         borderColor: "#FF5722",
          //         color: "#fff",
          //         boxShadow: "0 3px 10px rgba(255,87,34,0.3)",
          //       }
          //     : {}
          // }
        >
          {item.btnText}
        </Button>
      );
    };

    return !isLoading ? (
      <div className="loading" />
    ) : (
      <React.Fragment>
        {/* Downgrade Confirm Modal */}
        <Modal
          isOpen={this.state.modal_downgrade_confirm}
          toggle={this.toggleDowngradeConfirm}
        >
          <ModalHeader toggle={this.toggleDowngradeConfirm}>
            <IntlMessages id="upgrade.modal.downgrade.title" />
          </ModalHeader>
          <ModalBody>
            {this.state.downgradePreview ? (
              <div>
                <p>
                  <IntlMessages id="upgrade.modal.downgrade.intro" />
                </p>
                <ul>
                  <li>
                    <IntlMessages id="upgrade.modal.downgrade.remaining-value" />{" "}
                    <b>
                      {new Intl.NumberFormat("vi-VN", {
                        style: "currency",
                        currency: "VND",
                      }).format(
                        this.state.downgradePreview.totalRemainingValue,
                      )}
                    </b>{" "}
                    <IntlMessages
                      id="upgrade.modal.downgrade.equivalent"
                      values={{
                        days: this.state.downgradePreview.remainingDays,
                      }}
                    />
                  </li>
                  <li>
                    <IntlMessages id="upgrade.modal.downgrade.exchange" />{" "}
                    <b>
                      {this.state.downgradePreview.totalMonths > 0
                        ? (() => {
                            const months = this.state.downgradePreview.totalMonths;
                            const years = Math.floor(months / 12);
                            const remainMonths = months % 12;
                            let text = "";
                            if (years > 0) text += `${years} năm `;
                            if (remainMonths > 0) text += `${remainMonths} tháng`;
                            return text.trim();
                          })()
                        : intl.formatMessage({
                            id: "upgrade.modal.downgrade.ineligible",
                          })}
                    </b>
                  </li>
                  {this.state.downgradePreview.surplus > 0 && (
                  <li>
                    <IntlMessages id="upgrade.modal.downgrade.refund" />{" "}
                    <b>
                      {new Intl.NumberFormat("vi-VN", {
                        style: "currency",
                        currency: "VND",
                      }).format(Math.round(this.state.downgradePreview.surplus))}
                    </b>
                  </li>
                  )}
                </ul>
                <p className="text-danger">
                  <IntlMessages id="upgrade.modal.downgrade.warning" />
                </p>
              </div>
            ) : (
              <div className="text-center">
                <div className="loading" />
                <p>
                  <IntlMessages id="upgrade.modal.downgrade.calculating" />
                </p>
              </div>
            )}
            <div className="text-right mt-3">
              <Button
                color="secondary"
                outline
                onClick={this.toggleDowngradeConfirm}
                className="mr-2"
              >
                <IntlMessages id="upgrade.modal.downgrade.cancel" />
              </Button>
              <Button
                color="danger"
                onClick={this.handleDowngradeConfirm}
                disabled={
                  !this.state.downgradePreview ||
                  !this.state.downgradePreview.totalMonths
                }
              >
                <IntlMessages id="upgrade.modal.downgrade.confirm" />
              </Button>
            </div>
          </ModalBody>
        </Modal>

        {/* Payment Success Modal */}
        <Modal
          isOpen={modal_payment_success}
          toggle={this.togglePaymentSuccess}
        >
          <ModalHeader toggle={this.togglePaymentSuccess}>
            <i className="simple-icon-check text-success mr-2" />
            <IntlMessages id="upgrade.modal.success.title" />
          </ModalHeader>
          <ModalBody className="text-center">
            <div className="mb-4">
              <i
                className="iconsminds-diamond text-primary"
                style={{ fontSize: "4rem" }}
              />
            </div>
            <h4 className="mb-3">
              <IntlMessages id="upgrade.modal.success.msg" />
            </h4>
            {paymentInfo && (
              <div>
                {paymentInfo.upgraded ? (
                  <p className="text-success font-weight-bold">
                    <IntlMessages id="upgrade.modal.success.lifetime" />
                  </p>
                ) : (
                  <p>
                    <IntlMessages id="upgrade.modal.success.new-expiry" />{" "}
                    <strong className="text-primary">
                      {paymentInfo.expired_date}
                    </strong>
                  </p>
                )}
              </div>
            )}
            <Button color="primary" onClick={this.togglePaymentSuccess}>
              <IntlMessages id="upgrade.modal.success.close" />
            </Button>
          </ModalBody>
        </Modal>

        {/* Package Payment Modals */}
        {this.renderPaymentModal(
          modal_basic,
          this.toggleBasic,
          priceSelectedBasic,
          this.getPricesBasic(intl),
          this.handleChangeValueSelectPriceBasic,
          this.handleActionSubmitBasic,
          "basic",
        )}

        {this.renderPaymentModal(
          modal_pro,
          this.togglePro,
          priceSelectedPro,
          this.getPricesPro(intl),
          this.handleChangeValueSelectPricePro,
          this.handleActionSubmitPro,
          "pro",
        )}

        {this.renderPaymentModal(
          modal_pro_auto,
          this.toggleProAuto,
          priceSelectedProAuto,
          this.getPricesProAuto(intl),
          this.handleChangeValueSelectPriceProAuto,
          this.handleActionSubmitProAuto,
          "pro_auto",
        )}

        {/* Enterprise Contact Modal */}
        <Modal isOpen={modal_enterprise} toggle={this.toggleEnterprise} size="lg">
          <ModalHeader toggle={this.toggleEnterprise}>
            <i className="iconsminds-building mr-2" />
            Liên hệ gói Enterprise
          </ModalHeader>
          <ModalBody>
            {contactSent ? (
              <div className="text-center py-4">
                <i
                  className="simple-icon-check text-success"
                  style={{ fontSize: "48px" }}
                />
                <h4 className="mt-3 text-success">Gửi thành công!</h4>
                <p className="text-muted">
                  Chúng tôi đã nhận được yêu cầu của bạn và sẽ phản hồi trong thời gian sớm nhất.
                </p>
                <Button color="primary" onClick={this.toggleEnterprise}>
                  Đóng
                </Button>
              </div>
            ) : (
              <div>
                <Card className="mb-4 border">
                  <CardBody>
                    <h5 className="font-weight-bold mb-3">
                      <i className="iconsminds-shop-4 mr-2 text-primary" />
                      Thông tin VMASS
                    </h5>
                    <Row>
                      <Colxx xxs="12" md="6">
                        <p className="mb-2">
                          <i className="simple-icon-phone mr-2 text-muted" />
                          <strong>Hotline:</strong>{" "}
                          <a href="tel:0935777736">0935 777 736</a>
                        </p>
                        <p className="mb-2">
                          <i className="simple-icon-envelope-letter mr-2 text-muted" />
                          <strong>Email:</strong>{" "}
                          <a href="mailto:lienhe@vmass.vn">lienhe@vmass.vn</a>
                        </p>
                      </Colxx>
                      <Colxx xxs="12" md="6">
                        <p className="mb-2">
                          <i className="simple-icon-globe mr-2 text-muted" />
                          <strong>Website:</strong>{" "}
                          <a href="https://vmass.vn" target="_blank" rel="noopener noreferrer">vmass.vn</a>
                        </p>
                        <p className="mb-2">
                          <i className="simple-icon-location-pin mr-2 text-muted" />
                          <strong>Địa chỉ:</strong>{" "}
                          Đà Nẵng, Việt Nam
                        </p>
                      </Colxx>
                    </Row>
                  </CardBody>
                </Card>

                <h5 className="font-weight-bold mb-3">
                  <i className="simple-icon-envelope-open mr-2 text-primary" />
                  Gửi yêu cầu tư vấn
                </h5>
                <Row>
                  <Colxx xxs="12" md="6">
                    <FormGroup>
                      <Label>Họ và tên *</Label>
                      <Input
                        value={contactForm.name}
                        onChange={(e) => this.onContactFormChange("name", e.target.value)}
                        placeholder="Nguyễn Văn A"
                      />
                    </FormGroup>
                  </Colxx>
                  <Colxx xxs="12" md="6">
                    <FormGroup>
                      <Label>Email *</Label>
                      <Input
                        type="email"
                        value={contactForm.email}
                        onChange={(e) => this.onContactFormChange("email", e.target.value)}
                        placeholder="email@company.com"
                      />
                    </FormGroup>
                  </Colxx>
                </Row>
                <FormGroup>
                  <Label>Số điện thoại</Label>
                  <Input
                    value={contactForm.phone}
                    onChange={(e) => this.onContactFormChange("phone", e.target.value)}
                    placeholder="0912 345 678"
                  />
                </FormGroup>
                <FormGroup>
                  <Label>Nội dung *</Label>
                  <Input
                    type="textarea"
                    rows={4}
                    value={contactForm.message}
                    onChange={(e) => this.onContactFormChange("message", e.target.value)}
                    placeholder="Mô tả nhu cầu sử dụng gói Enterprise của bạn..."
                  />
                </FormGroup>
                <div className="text-right mt-3">
                  <Button
                    color="secondary"
                    outline
                    onClick={this.toggleEnterprise}
                    className="mr-2"
                  >
                    Hủy
                  </Button>
                  <Button
                    color="primary"
                    onClick={this.handleContactSubmit}
                    disabled={contactSubmitting}
                  >
                    {contactSubmitting ? (
                      <span><span className="spinner-border spinner-border-sm mr-1" /> Đang gửi...</span>
                    ) : (
                      <span><i className="simple-icon-paper-plane mr-1" /> Gửi liên hệ</span>
                    )}
                  </Button>
                </div>
              </div>
            )}
          </ModalBody>
        </Modal>

        <Row>
          <Colxx xxs="12">
            <Breadcrumb heading="menu.upgrade" match={this.props.match} />
            <Separator className="mb-5" />
          </Colxx>
        </Row>

        <div className="pb-5">
          <h2 className="text-center mb-5 font-weight-bold">Compare Plans</h2>

          <div className="table-responsive">
            <PerfectScrollbar
              options={{ suppressScrollY: true, wheelPropagation: true }}
            >
              <table className="table table-borderless table-upgrade">
                <thead>
                  <tr>
                    <th style={{ width: "20%" }}></th>
                    {packageConfig.map((item, index) => (
                      <th
                        key={index}
                        className={`text-center align-bottom px-3 ${
                          item.isPopular
                            ? "popular-column-header pricing-highlight-bg"
                            : ""
                        }`}
                        style={
                          item.isPopular
                            ? {
                                borderTopLeftRadius: "15px",
                                borderTopRightRadius: "15px",
                                border: "2px solid #922c88",
                                borderBottom: "none",
                                position: "relative",
                                zIndex: 10,
                                paddingTop: "40px",
                                paddingBottom: "30px",
                              }
                            : {
                                paddingBottom: "30px",
                              }
                        }
                      >
                        <h4 className="font-weight-bold mb-2">{item.title}</h4>
                        <h2
                          className="font-weight-bold mb-0"
                          style={{ color: item.isPopular ? "#000" : "inherit" }}
                        >
                          {item.price}
                          <small
                            className="text-small text-muted"
                            style={{ fontSize: "14px" }}
                          >
                            {item.sub}
                          </small>
                        </h2>
                        <div className="mt-4">{getButton(item)}</div>
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td
                      colSpan={packageConfig.length + 1}
                      className="font-weight-bold py-3"
                    >
                      <i className="iconsminds-check text-primary mr-2" />
                      <IntlMessages id="upgrade.features" />
                    </td>
                  </tr>
                  {features.map((feature, fIdx) => (
                    <tr key={fIdx}>
                      <td className="py-3 align-middle border-bottom text-muted font-weight-medium">
                        {feature.title}
                      </td>
                      {packageConfig.map((item, pIdx) => {
                        const val = feature[item.key];
                        let content = (
                          <i className="simple-icon-minus text-muted" />
                        );

                        if (val === true) {
                          content = (
                            <div
                              className="rounded-circle d-inline-flex justify-content-center align-items-center bg-primary"
                              style={{
                                width: "24px",
                                height: "24px",
                                color: "white",
                              }}
                            >
                              <i
                                className="simple-icon-check"
                                style={{ fontSize: "12px" }}
                              />
                            </div>
                          );
                        } else if (val === false) {
                          content = (
                            <i className="simple-icon-close text-danger" />
                          );
                        } else if (
                          typeof val === "string" ||
                          typeof val === "number"
                        ) {
                          content = (
                            <span className="font-weight-bold">{val}</span>
                          );
                        }

                        return (
                          <td
                            key={pIdx}
                            className={`text-center align-middle border-bottom ${
                              item.isPopular
                                ? "popular-column-body pricing-highlight-bg"
                                : ""
                            }`}
                            style={
                              item.isPopular
                                ? {
                                    borderLeft: "2px solid #922c88",
                                    borderRight: "2px solid #922c88",
                                  }
                                : {}
                            }
                          >
                            {content}
                          </td>
                        );
                      })}
                    </tr>
                  ))}
                  <tr>
                    <td></td>
                    {packageConfig.map((item, index) => (
                      <td
                        key={index}
                        className={`text-center align-middle ${
                          item.isPopular
                            ? "popular-column-footer pricing-highlight-bg"
                            : ""
                        }`}
                        style={
                          item.isPopular
                            ? {
                                borderBottomLeftRadius: "15px",
                                borderBottomRightRadius: "15px",
                                border: "2px solid #4f6dadff",
                                borderTop: "none",
                                paddingBottom: "20px",
                              }
                            : {}
                        }
                      ></td>
                    ))}
                  </tr>
                </tbody>
              </table>
            </PerfectScrollbar>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default injectIntl(Upgrade);
